import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-brand',
  templateUrl: './sidebar-brand.component.html',
  styleUrls: ['./sidebar-brand.component.scss']
})
export class SidebarBrandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
